/* eslint-disable camelcase */


// @vue/component
export default {
  name: 'TheMobileMenu',
  computed: {
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
    activeRouteName() {
      return this.$route.name;
    },
    isMobileMenuOpen() {
      return this.$store.getters['app/isMenuExpanded'];
    },
  },


  methods: {
    handleToggleMenu() {
      this.$store.dispatch('app/toggleMenu');
    },
  },
};
